var PrivilegeEnum;
(function (PrivilegeEnum) {
    PrivilegeEnum["normal"] = "NORMAL";
    PrivilegeEnum["admin"] = "ADMIN";
})(PrivilegeEnum || (PrivilegeEnum = {}));
export default PrivilegeEnum;
